import UserList from "./UserList";
import UserShow from "./UserShow";

const index = {
  list: UserList,
  show: UserShow,
};

export default index;
